module.exports = __webpack_public_path__ + "img/椭圆564.0cb7ce70.png";